import { Auth } from "firebase/auth";

export const checkAndRefreshToken = async (auth: Auth): Promise<void> => {
  if (!auth.currentUser) return;

  try {
    // Force token refresh to get latest claims
    const token = await auth.currentUser.getIdToken(true);

    // Parse the token to check claims size (rough estimate)
    const payload = JSON.parse(atob(token.split(".")[1]));
    const claimsSize = JSON.stringify(payload).length;

    // If claims are approaching the limit, the next event creation will trigger trimming
    if (claimsSize > 800) {
      console.log(
        `Token claims are approaching limit (${claimsSize} bytes). Next event creation will trigger trimming.`,
      );
    }
  } catch (error) {
    console.error("Error checking token size:", error);
  }
};

export const forceTokenRefresh = async (auth: Auth): Promise<void> => {
  if (!auth.currentUser) return;

  try {
    await auth.currentUser.getIdToken(true);
  } catch (error) {
    console.error("Error refreshing token:", error);
  }
};
